/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type StartHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  isTakeOver?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type StartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export const StartHandlingVehicleDocument = gql`
    mutation StartHandlingVehicle($vehicleId: ID!, $isTakeOver: Boolean) {
  fccStartHandlingVehicle(vehicleId: $vehicleId, isTakeOver: $isTakeOver)
}
    `
export type StartHandlingVehicleMutationFn = Apollo.MutationFunction<
  StartHandlingVehicleMutation,
  StartHandlingVehicleMutationVariables
>

/**
 * __useStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startHandlingVehicleMutation, { data, loading, error }] = useStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      isTakeOver: // value for 'isTakeOver'
 *   },
 * });
 */
export function useStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartHandlingVehicleMutation,
    StartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    StartHandlingVehicleMutation,
    StartHandlingVehicleMutationVariables
  >(StartHandlingVehicleDocument, options)
}
export type StartHandlingVehicleMutationHookResult = ReturnType<
  typeof useStartHandlingVehicleMutation
>
export type StartHandlingVehicleMutationResult =
  Apollo.MutationResult<StartHandlingVehicleMutation>
export type StartHandlingVehicleMutationOptions = Apollo.BaseMutationOptions<
  StartHandlingVehicleMutation,
  StartHandlingVehicleMutationVariables
>
